"use strict"

import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import { Button } from "react-bootstrap"

import { API_STATUS } from "../../../../shared_components/widgets/utils"
import { logToServer } from "../../../../ErrorBoundary"
import { addNewObject } from "../../../../Loaders"

const styles = {
  icon: {
    height: "100px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "500",
    marginTop: "10px",
    color: "var(--lanzalake-black)",
  },
  message: {
    marginTop: "8px",
    maxHeight: "100px",
    overflowY: "auto",
  },
}

export default function ServiceLogsWidget() {
  // --- States ---
  const [state_backup, setStateBackup] = useState(null)
  const [backup_result, setBackupResult] = useState(null)

  // --- Events ---
  const onClick_backup = (event) => {
    event.preventDefault()
    setStateBackup(API_STATUS.LOADING)
    setBackupResult(null)

    addNewObject("/administration/api/logs/backup_logs/", {})
      .then((data) => {
        setStateBackup(null)
        setBackupResult(data)
        alert("Success! " + data.message)
      })
      .catch((error) => {
        logToServer(error)
        setStateBackup(null)

        if (error.message) {
          setBackupResult(error)
          alert("Error! Unable to create backup:\n" + error.message)
        } else {
          alert("Error! Something went wrong while requesting logs backup:\n" + error)
        }
      })
  }

  return (
    <div className={"card"}>
      <div className={"card-body"}>
        <div style={{ marginBottom: "20px" }} align={"center"}>
          <span className={"fa fa-files-o"} style={{ fontSize: "97px" }} />
          <div style={styles.title}>Backup Logs</div>
          {backup_result !== null && (
            <div
              style={styles.message}
              className={
                backup_result.status === "success"
                  ? "text-success"
                  : backup_result.status === "partial_success"
                    ? "text-warning"
                    : "text-danger"
              }
            >
              {backup_result.message}
            </div>
          )}
        </div>

        <Button
          variant={"primary"}
          className={"btn btn-sm"}
          style={{ width: "100%" }}
          onClick={onClick_backup}
          disabled={state_backup === API_STATUS.LOADING}
        >
          {state_backup === API_STATUS.LOADING ? (
            <>
              <FormattedMessage id={"administration.database-backup.creating-backup"} />
              ...
            </>
          ) : (
            <FormattedMessage id={"administration.database-backup.create-backup"} />
          )}
        </Button>
      </div>
    </div>
  )
}
